import { ChangeDetectorRef, Component, DestroyRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FormlyConfig, FormlyFieldConfig } from '@ngx-formly/core';
import { FormStateService } from '../../module/service-provider/add-sp-new-component/form-state.service';
import { ServiceProviderService } from '../../Service/Service-providers/service-provider.service';
import { ActivatedRoute } from '@angular/router';
import { ToastService } from '../../Service/ToastService/toast.service';
import { ServiceProviderSelectorComponent } from '../type/formly-selector-type';

@Component({
  selector: 'app-distributor-business-details',
  templateUrl: './distributor-business-details.component.html',
  styleUrl: './distributor-business-details.component.scss'
})
export class DistributorBusinessDetailsComponent implements OnInit, OnDestroy {

  @Input() phoneNumber!: string;
  form = new FormGroup({});
  // model: any = {};
  model: any = {
    businessName: '',
    commercialRegistrationNumber: '',
    countryId: '',
    stateId: '',
    districtId: '',
    yearOfEstablishment: '',
    gstNumber: '',
    CommercialRegistrationNumberId: '',
    district: '',
    city: '',
    zip: '',
    address: '',
    Insuranceofdealershipproof: '',
    certificateOfIncorporation: '',
    website: '',
    authorisedDelarshipProofUrl: '',
    //frontViewFileIds: '',
    businessTypeId: '',
    frontViewFileIds: [],
    //distributorNetworks: [],
    documents: [],
    // distributorNetworks: [{}],
  };

  fields: FormlyFieldConfig[] = [];
  selectedBusinessType!: string;
  @Output() isValid = new EventEmitter<boolean>();
  @Output() nextSection = new EventEmitter<void>();
  @Input() countryId!: string;
  @Output() clearForm = new EventEmitter<void>();
  @Output() editServiceProviderList: EventEmitter<void> =
    new EventEmitter<void>();
  businessTypes = [];
  receivedObject: any;
  @Output() onFinish = new EventEmitter<void>();
  @Output() formSubmitted = new EventEmitter<void>();
  @Input() idRecieved: any
  last35Years: { label: string, value: number }[] = [];
  stateOptions: { label: string, value: number }[] = [];
  countryName!: string;
  role: string = '';
  stateId: any

  constructor(
    private fb: FormBuilder,
    private formStateService1: FormStateService,
    private api: ServiceProviderService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private toastService: ToastService,
    private formlyConfig: FormlyConfig
  ) { }


  ngOnInit() {
    this.loadFormData();


    // display last 35 years
    const currentYear = new Date().getFullYear();
    this.last35Years = Array.from({ length: 35 }, (_, i) => {
      const year = currentYear - i;
      return { label: year.toString(), value: year };
    });
    console.log('recieved Id in the business details', this.idRecieved)
    console.log('BusinessDetailsNewComponent initialized');
    const userDetailsString = localStorage.getItem('user');
    if (userDetailsString) {
      const userDetails = JSON.parse(userDetailsString);
      this.countryId = userDetails.country?.countryId;
      this.countryName = userDetails.country?.name;

      if (this.countryId) {
        console.log('CountryId from localStorage:', this.countryId);
        this.model.countryId = this.countryId;
        this.initializeFields();
        this.form.patchValue({ countryId: this.countryId });
      }
    }
    this.api.getBusinessTypeList('').subscribe({
      next: (businessTypes: any) => {
        this.businessTypes = businessTypes || [];

        // Directly update only the `businessTypeId` field
        const businessTypeField = this.findFieldByKey(this.fields, 'businessTypeId');
        if (businessTypeField) {
          businessTypeField.templateOptions!.options = this.businessTypes.map((x: any) => ({
            value: x.businessTypeId,
            label: x.name,
          }));
        }
      },
      error: (err) => {
        console.error('Error fetching business types:', err);
      }
    });
  }

  ngOnDestroy() {
    this.saveFormData();
  }

  initializeFields() {
    console.log('initialize field is called')
    const businessTypeOptions = (this.businessTypes || []).map((x: any) => ({
      value: x.businessTypeId,
      label: x.name,
    }
    )
    );
    this.fields = [
      {
        className: 'field col-12',
        template: '<h3 style="mt-0">Basics</h3>',
      },
      {
        fieldGroupClassName: 'p-fluid p-formgrid p-grid',
        fieldGroup: [
          {
            fieldGroupClassName: 'field grid p-fluid',
            fieldGroup: [
              {
                className: 'field col',
                type: 'input',
                key: 'businessName',
                templateOptions: {
                  label: 'Name of the Business',
                  placeholder: 'Enter Name',
                  required: true,
                  hideRequiredMarker: true,
                  pattern: '^[a-zA-Z][a-zA-Z\\s\\-\\.]*$',
                },
                validation: {
                  messages: {
                    pattern: 'Name must contain only letters and spaces',
                  }
                },
                modelOptions: {
                  updateOn: 'change'
                }
              },
              {
                className: 'field col',
                key: 'yearOfEstablishment',
                type: 'select',
                templateOptions: {
                  placeholder: 'Select Year of Commencement',
                  label: 'Year of Commencement',
                  required: true,
                  hideRequiredMarker: true,
                  options: this.last35Years,
                },
                defaultValue: '',

              },
            ],
          },
          // {
          //   template: `<div class="mt-1"></div>`,
          // },
          {
            fieldGroupClassName: 'field grid p-fluid',
            fieldGroup: [
              {
                className: 'field col-6',
                key: 'businessTypeId',
                type: 'select',
                templateOptions: {
                  label: 'Business Type',
                  placeholder: 'Select Business Type',
                  options: businessTypeOptions,
                  required: true,
                  hideRequiredMarker: true,
                },

              },
              {
                className: 'field col-6',
                key: 'commercialRegistrationNumber',
                type: 'input',

                templateOptions: {
                  label: 'Commercial Registration Number',
                  placeholder: 'Enter Number',
                  required: true,
                  hideRequiredMarker: true,
                },

              },
            ],
          },
          // {
          //   template: `<div class="mt-0"></div>`,
          // },
          {
            className: 'field col-12',
            template: '<h3>Commercial Registration Number</h3>',
          },
          {
            key: 'CommercialRegistrationNumberId',
            type: 'file',
            templateOptions: {
              placeholder: 'Upload',
              required: true,
              hideRequiredMarker: true,
              fileSourceId: 6,
            },
            validation: {
              messages: {
                required: () => 'Upload Commercial Registration Number',
              },
            },
          },
          {
            className: 'field col-12 ',
            template: '<h3 class="BAddress">Business Address</h3>',
          },
          {
            fieldGroupClassName: 'field grid p-fluid',
            fieldGroup: [
              {
                className: 'field col',
                key: 'zip',
                type: 'input',
                templateOptions: {
                  label: 'Area Pincode',
                  placeholder: 'Enter PinCode',
                  required: true,
                  //hideLabel: true,
                  hideRequiredMarker: true,
                },
                validators: {
                  zip: {
                    expression: (c: AbstractControl) =>
                      /^[1-9][0-9]{5}$/.test(c.value),
                    message: (error: any, field: FormlyFieldConfig) =>
                      `${field.formControl?.value} is not a valid Pincode`,
                  },

                },
              },
              {
                className: 'field col-6',
                key: 'city',
                type: 'input',
                templateOptions: {
                  label: 'City',
                  placeholder: 'Enter City',
                  required: true,
                  //hideLabel: true,
                  hideRequiredMarker: true,
                },

              },
            ],
          },
          {
            template: `<div class="mt-1"></div>`,
          },
          {
            fieldGroupClassName: 'field grid p-fluid',
            fieldGroup: [
              {
                className: 'field col',
                key: 'countryId',
                type: 'select',
                templateOptions: {
                  disabled: true,
                  options: this.api.getCountry(''),
                  placeholder: 'Select a country',
                  valueProp: 'countryId',
                  labelProp: 'name',
                  label: 'Country',
                  hideRequiredMarker: true,
                },
                hooks: {
                  onInit: (field) => {
                    if (this.countryId) {
                      field.formControl?.setValue(this.countryId);
                      field.templateOptions!.disabled = true;
                    }
                  },
                },
              },
              {
                className: 'field col-6',
                key: 'stateId',
                type: 'select',
                templateOptions: {
                  placeholder: 'Select State',
                  options: [],
                  valueProp: 'stateId',
                  labelProp: 'name',
                  label: 'State',
                  required: true,
                  hideRequiredMarker: true,
                },
                hooks: {
                  onInit: (field) => {
                    // Fetch states when initializing
                    this.api.getStatesByCountry(this.countryId).subscribe(states => {
                      field.templateOptions!.options = states;
                    });

                    // Set a listener for value changes
                    field.formControl?.valueChanges.subscribe((selectedStateId: number) => {
                      this.stateId = selectedStateId;

                      // Now fetch districts using selected stateId
                      const districtField = this.findFieldByKey(this.fields, 'districtId');
                      if (districtField) {
                        this.api.getDistrictsByStates(selectedStateId).subscribe(districts => {
                          districtField.templateOptions!.options = districts;
                          this.cdr.markForCheck();
                        });
                      }
                    });
                  }
                }
              },
            ],

          },
          {
            fieldGroupClassName: 'field grid p-fluid',
            fieldGroup: [

              {
                className: 'field col-6',
                key: 'districtId',
                type: 'select',
                templateOptions: {
                  placeholder: 'Select district',
                  options: [], // Leave empty initially
                  valueProp: 'districtId',
                  labelProp: 'name',
                  label: 'District',
                  required: true,
                  hideRequiredMarker: true,
                },
              },
              {
                className: 'field col-6',
                key: 'address',
                type: 'input',
                templateOptions: {
                  label: 'Address',
                  placeholder: 'Enter Address',
                  required: true,
                  //hideLabel: true,
                  hideRequiredMarker: true,
                  disabled: true,
                },
              },


            ]

          },

          {
            className: 'field col-12',
            template: `
                <h3>Business Network</h3>
                <p>Enter the number of UIOs, garages, spare parts shops, and OEM dealerships you own or operate.</p>
              `,
          },
          {
            key: 'distributorNetworks',
            type: 'service-provider-selector',
            templateOptions: {
              label: 'Select Service Provider Type',
              required: true,
              hideRequiredMarker: true,
            },
            validators: {
              required: {
                expression: (c: AbstractControl) => {
                  return Array.isArray(c.value) && c.value.length > 0;
                },
                message: () => 'Please select at least one service provider type',
              }
            }
          },

          // {
          //   template: `<div class="mt-3"></div>`,
          // },
          {
            className: 'field col-12',
            template: '<h3 class="BAddress">Others</h3>',
          },
          {
            fieldGroupClassName: 'field grid p-fluid',
            fieldGroup: [
              {
                className: 'field col',
                key: 'authorisedDelarshipProofUrl',
                type: 'input',
                templateOptions: {
                  label: 'Authorized dealership (Manufacturer) Website',
                  placeholder: 'Enter OEM link/Dealer Website',
                  required: true,
                  //hideLabel: true,
                  hideRequiredMarker: true,
                },


              },
            ],
          },
          {
            fieldGroupClassName: 'field grid p-fluid',
            fieldGroup: [
              {
                className: 'field col',
                key: 'website',
                type: 'input',
                templateOptions: {
                  label: 'Dealership Website',
                  placeholder: 'Enter Website link',
                  required: true,
                  //hideLabel: true,
                  hideRequiredMarker: true,
                },
              },
            ],
          },
          {
            type: 'input',
            key: 'gstNumber',
            templateOptions: {
              label: 'GST Number',
              placeholder: 'Enter GST Number',
              required: true,
              hideRequiredMarker: true,
            },
            validators: {
              gst: {
                expression: (c: AbstractControl) =>
                  /^[0-9]{2}[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9A-Za-z]{1}[Z]{1}[0-9a-zA-Z]{1}$/.test(
                    c.value
                  ),
                message: (error: any, field: FormlyFieldConfig) =>
                  `${field.formControl?.value} is not a valid GST Number`,
              },
            },
          },
          {
            template: `<div class="mt-2"></div>`,
          },
          {
            template: `<div class="mt-6 mb-3"><strong>Front view photo of business/shop</strong></div>`,
          },
          {
            key: 'frontViewFileIds',
            type: 'multifile',
            templateOptions: {
              placeholder: 'Upload',
              required: true,
              hideRequiredMarker: true,
              fileSourceId: 6,
              accept: "image/png, image/jpeg",
            },
            defaultValue: [],
            validators: {
              required: {
                expression: (control: FormControl) => {
                  return control.value && Array.isArray(control.value) && control.value.length > 0;
                },
                message: 'Upload Front view photo of business/shop'
              }
            }
          },
          {
            template: `<div class="mt-6"><strong>Certificate of incorporation</strong></div>`,
          },
          {
            template: `<div class="mt-3"></div>`,
          },
          {
            key: 'commercialRegistrationNumber',
            type: 'input',
            templateOptions: {
              placeholder: 'Enter Commercial Registration Number',
              required: true,
              hideRequiredMarker: true,
            },
            validation: {
              messages: {
                required: () => 'Upload Certificate of incorporation',
              },
            },
            expressions: {
              hide: 'model.countryId!==2',
            },
          },
          {
            template: `<div class="mt-3"></div>`,
          },
          {
            key: 'certificateOfIncorporation',
            type: 'file',
            templateOptions: {
              placeholder: 'Upload',
              required: true,
              hideRequiredMarker: true,
              fileSourceId: 6,
            },
            validation: {
              messages: {
                required: () => 'Upload Certificate of incorporation',
              },
            },
          },
          {
            template: `<div class="mt-6"><strong>Insurance of dealership proof</strong></div>`,
          },
          {
            template: `<div class="mt-3"></div>`,
          },
          {
            key: 'Insuranceofdealershipproof',
            type: 'file',
            templateOptions: {
              placeholder: 'Upload',
              required: true,
              hideRequiredMarker: true,
              fileSourceId: 6,
            },
            validation: {
              messages: {
                required: () => 'Upload Insurance of dealership proof',
              },
            },

          },
        ],
      },
    ];
  }

  findFieldByKey(
    fields: FormlyFieldConfig[],
    key: string
  ): FormlyFieldConfig | null {
    for (const field of fields) {
      if (field.key === key) {
        return field;
      }
      if (field.fieldGroup && field.fieldGroup.length > 0) {
        const nestedField = this.findFieldByKey(
          field.fieldGroup as FormlyFieldConfig[],
          key
        );
        if (nestedField) {
          return nestedField;
        }
      }
    }
    return null;
  }

  loadFormData() {
  const savedBusinessData = this.formStateService1.getFormData('business-details');
  const mapLocationData = this.formStateService1.getFormData('map-location');

  if (mapLocationData?.address) {
    this.model.address = mapLocationData.address;
    // this.form.patchValue({ address: mapLocationData.address });
    console.log('Address loaded from map-location:', mapLocationData.address);
  } else if (savedBusinessData?.address) {
    this.model.address = savedBusinessData.address;
  }

  if (savedBusinessData) {
    this.model = {
      ...savedBusinessData,
      address: this.model.address 
      // address: mapLocationData?.address || savedBusinessData.address || ''
    };
    this.form.patchValue(this.model);
    this.cdr.markForCheck();
  }
}


  // clearFormData() {
  //   this.formStateService1.clearFormData();
  //   this.form.reset();
  //   this.model = {};
  //   this.initializeFields();
  //   console.log('BusinessDetailsNewComponent: Form data cleared.');
  // }
  resetForm() {
    this.form.reset();
    this.model = {};
    this.initializeFields();
  }

  saveFormData() {
    this.model.documents = [
      { documentTypeId: 6, fileId: this.model.certificateOfIncorporation },
      { documentTypeId: 19, fileId: this.model.Insuranceofdealershipproof },
      { documentTypeId: 17, fileId: this.model.CommercialRegistrationNumberId }
    ];
    const formData = this.form.value || { ...this.model };
    this.formStateService1.setFormData('business-details', formData);
    console.log('Form Data Saved:', formData);
  }

  onSubmit() {

    if (this.form.valid) {
       const mapLocationData = this.formStateService1.getFormData('map-location');
    const address = this.model.address || mapLocationData?.address || '';
    
    // Manually include the address in the form value
    const formValue = {
      ...this.form.value,
      address: address
    };
      const businessData = this.transformBusinessData(formValue);

      if (!this.idRecieved) {
        this.formStateService1.setBusinessDetails(businessData);
        console.log('Business details saved to formStateService:', businessData);
      } else {
        console.log('Edit mode detected. Skipping setBusinessDetails. ID:', this.idRecieved);
      }

      this.nextSection.emit();
      this.cdr.detectChanges();
    }
  }


  transformBusinessData(formData: any): any {
    const mapLocationData = this.formStateService1.getFormData('map-location');
    const address = formData.address || mapLocationData?.address || '';
    const businessData: any = {
      businessName: formData.businessName,
      businessTypeId: this.model.businessTypeId || formData.businessTypeId,
      yearOfEstablishment: formData.yearOfEstablishment ? Number(formData.yearOfEstablishment) : null,
      commercialRegistrationNumber: formData.commercialRegistrationNumber,
      city: formData.city,
      zip: formData.zip,
      address: address,
      countryId: this.countryId,
      stateId: this.model.stateId || formData.stateId || null,
      districtId: formData.districtId,
      gstNumber: formData.gstNumber || null,
      vatNumber: formData.vatNumber || null,
      website: formData.website,
      authorisedDelarshipProofUrl: formData.authorisedDelarshipProofUrl,
      frontViewFileIds: formData.frontViewFileIds,
      distributorNetworks: formData.distributorNetworks.map((network: any) => ({
        serviceProviderTypeId: network.serviceProviderTypeId,
        distributorNetworkSubType: network.distributorNetworkSubType.map((sub: any) => ({
          serviceProviderSubTypeId: sub.serviceProviderSubTypeId,
          count: sub.count > 0 ? sub.count : 0
        }))
      })),
      documents: [
        { documentTypeId: 6, fileId: formData.certificateOfIncorporation },
        { documentTypeId: 19, fileId: formData.Insuranceofdealershipproof },
        { documentTypeId: 17, fileId: formData.CommercialRegistrationNumberId }
      ],
    };
    return businessData;
  }

  populateFormWithDistributorDetails(res: any) {
    if (!res) return;
    console.log(res);
    const mapLocationData = this.formStateService1.getFormData('map-location');
    const address = mapLocationData?.address || res.address || '';

    const stateId = res.state?.stateId ;
    const districtId = res.districtId ;

    // Pre-fill all fields except districtId
    this.model = {
      businessName: res.businessName || '',
      businessTypeId: res.businessType?.businessTypeId || '',
      yearOfEstablishment: res.yearOfEstablishment,
      commercialRegistrationNumber: res.commercialRegistrationNumber || '',
      city: res.city || '',
      zip: res.zip || '',
      address: address ,
      countryId: res.country?.countryId || '',
      stateId: stateId,
      gstNumber: res.gstNumber || '',
      website: res.website || '',
      authorisedDelarshipProofUrl: res.authorisedDelarshipProofUrl || '',
      frontViewFileIds: res.frontViewFiles?.map((file: any) => file.fileId) || [],
      distributorNetworks: res.distributorNetworks?.map((network: any) => ({
        serviceProviderTypeId: network.serviceProviderTypeId,
        distributorNetworkSubType: network.distributorNetworkSubTypes?.map((sub: any) => ({
          serviceProviderSubTypeId: sub.serviceProviderSubTypeId,
          name: sub.name,
          count: sub.count || 0
        }))
      })) || [],
      certificateOfIncorporation: res.documents?.find((doc: any) => doc.documentTypeId === 6)?.fileId,
      Insuranceofdealershipproof: res.documents?.find((doc: any) => doc.documentTypeId === 19)?.fileId,
      CommercialRegistrationNumberId: res.documents?.find((doc: any) => doc.documentTypeId === 17)?.fileId,
    };

    this.initializeFields();
    this.form.patchValue(this.model);

    if (stateId) {
      this.api.getDistrictsByStates(stateId).subscribe(districts => {
        const districtField = this.findFieldByKey(this.fields, 'districtId');
        if (districtField) {
          districtField.templateOptions!.options = districts;

          // Now patch districtId only after options are loaded
          this.form.patchValue({ districtId });
          this.model.districtId = districtId;
          this.cdr.markForCheck();
        }
      });
    }

    this.cdr.detectChanges();
  }

}
